import { Suspense, lazy } from 'react';
import { Navigate, useRoutes, useLocation } from 'react-router-dom';
import DashboardLayout from '../layouts/dashboard';
import AuthGuard from '../guards/AuthGuard';
import { PATH_AFTER_LOGIN } from '../config';
import LoadingScreen from '../components/LoadingScreen';
import Authenticator from '../pages/auth/Authenticator';


// ----------------------------------------------------------------------

const Loadable = (Component) => (props) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { pathname } = useLocation();

  return (
    <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
      <Component {...props} />
    </Suspense>
  );
};

export default function Router() {
  return useRoutes([
    { path: '/', element: <Login/> },
    { path: '/authenticator', element: <Authenticator/> },
    { path: '/dashboard', element: <GeneralApp/> },
    {
          path: 'dashboard',
          element: (
            <AuthGuard>
              <DashboardLayout />
            </AuthGuard>
          ),
          children: [

            { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
            { path: 'home', element: <GeneralAnalytics /> },
            { path: 'dorm', element: <Dorm /> },
            { path: 'editdorm/:id', element: <EditDorm /> },
            { path: 'adddorm', element: <AddDorm /> },
            { path: 'element', element: <Element /> },
            { path: 'editelement/:id', element: <EditElement /> },
            { path: 'addelement', element: <AddElement /> },
            { path: 'magictype', element: <Magictype /> },
            { path: 'editmagictype/:id', element: <EditMagictype /> },
            { path: 'addmagictype', element: <AddMagictype /> },            
          
         
          ],
        },
  
  ]);
}

// AUTHENTICATION
const Login = Loadable(lazy(() => import('../pages/auth/Login')));

const Dorm = Loadable(lazy(() => import('../pages/dashboard/Dorm/SubAdmin')));
const EditDorm = Loadable(lazy(() => import('../pages/dashboard/Dorm/EditSubadmin')));
const AddDorm = Loadable(lazy(() => import('../pages/dashboard/Dorm/AddSubadmin')));

const Element = Loadable(lazy(() => import('../pages/dashboard/Element/Element')));
const EditElement = Loadable(lazy(() => import('../pages/dashboard/Element/EditElement')));
const AddElement = Loadable(lazy(() => import('../pages/dashboard/Element/AddElement')));

const Magictype = Loadable(lazy(() => import('../pages/dashboard/Magictype/Magictype')));
const EditMagictype = Loadable(lazy(() => import('../pages/dashboard/Magictype/EditMagictype')));
const AddMagictype = Loadable(lazy(() => import('../pages/dashboard/Magictype/AddMagictype')));
const GeneralApp = Loadable(lazy(() => import('../pages/dashboard/GeneralApp')));
const GeneralAnalytics = Loadable(lazy(() => import('../pages/dashboard/GeneralAnalytics')));
